import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {SmallCard} from '../../lib/small-card/small-card';
import {MeetingDateTimeInfo} from '../meeting-date-time-info/meeting-date-time-info';
import {CardChildren} from '../../lib/card-children/card-children';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import {selectCancellationPolicy} from '../../selectors/cancellation-selector';
import {RootMachineContext} from '../../machines/rootMachine';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';
import {TEST_ID} from '../../utils/testId';


export const CancellationPolicy = () => {
  const {t} = useLabelTranslation();
  const cancellationPolicy = RootMachineContext.useSelector((state) =>
    selectCancellationPolicy(state, t),
  );
  return (
    <SmallCard
      title={t('Cancel_Meeting', 'Cancel Meeting')}
      icon="calendar"
      testId={generateTestId({
        base: TEST_ID.CANCELLATION_POLICY,
        slot: 'small-card',
      })}
    >
      <MeetingDateTimeInfo />
      <CardChildren>
        <InContextAlert semantic="danger">
          {/* Note: user input data */}
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {cancellationPolicy}
        </InContextAlert>
      </CardChildren>
    </SmallCard>
  );
};
